export const CountryCodes = [
  {
    country: "Afghanistan",
    shortForm: "AF",
    code: "+93",
    flagEmoji: "🇦🇫",
  },
  {
    country: "Aland Islands",
    shortForm: "AX",
    code: "+358",
    flagEmoji: "🇦🇽",
  },
  {
    country: "Albania",
    shortForm: "AL",
    code: "+355",
    flagEmoji: "🇦🇱",
  },
  {
    country: "Algeria",
    shortForm: "DZ",
    code: "+213",
    flagEmoji: "🇩🇿",
  },
  {
    country: "AmericanSamoa",
    shortForm: "AS",
    code: "+1684",
    flagEmoji: "🇦🇸",
  },
  {
    country: "Andorra",
    shortForm: "AD",
    code: "+376",
    flagEmoji: "🇦🇩",
  },
  {
    country: "Angola",
    shortForm: "AO",
    code: "+244",
    flagEmoji: "🇦🇴",
  },
  {
    country: "Anguilla",
    shortForm: "AI",
    code: "+1264",
    flagEmoji: "🇦🇮",
  },
  {
    country: "Antarctica",
    shortForm: "AQ",
    code: "+672",
    flagEmoji: "🇦🇶",
  },
  {
    country: "Antigua and Barbuda",
    shortForm: "AG",
    code: "+1268",
    flagEmoji: "🇦🇬",
  },
  {
    country: "Argentina",
    shortForm: "AR",
    code: "+54",
    flagEmoji: "🇦🇷",
  },
  {
    country: "Armenia",
    shortForm: "AM",
    code: "+374",
    flagEmoji: "🇦🇲",
  },
  {
    country: "Aruba",
    shortForm: "AW",
    code: "+297",
    flagEmoji: "🇦🇼",
  },
  {
    country: "Australia",
    shortForm: "AU",
    code: "+61",
    flagEmoji: "🇦🇺",
  },
  {
    country: "Austria",
    shortForm: "AT",
    code: "+43",
    flagEmoji: "🇦🇹",
  },
  {
    country: "Azerbaijan",
    shortForm: "AZ",
    code: "+994",
    flagEmoji: "🇦🇿",
  },
  {
    country: "Bahamas",
    shortForm: "BS",
    code: "+1242",
    flagEmoji: "🇧🇸",
  },
  {
    country: "Bahrain",
    shortForm: "BH",
    code: "+973",
    flagEmoji: "🇧🇭",
  },
  {
    country: "Bangladesh",
    shortForm: "BD",
    code: "+880",
    flagEmoji: "🇧🇩",
  },
  {
    country: "Barbados",
    shortForm: "BB",
    code: "+1246",
    flagEmoji: "🇧🇧",
  },
  {
    country: "Belarus",
    shortForm: "BY",
    code: "+375",
    flagEmoji: "🇧🇾",
  },
  {
    country: "Belgium",
    shortForm: "BE",
    code: "+32",
    flagEmoji: "🇧🇪",
  },
  {
    country: "Belize",
    shortForm: "BZ",
    code: "+501",
    flagEmoji: "🇧🇿",
  },
  {
    country: "Benin",
    shortForm: "BJ",
    code: "+229",
    flagEmoji: "🇧🇯",
  },
  {
    country: "Bermuda",
    shortForm: "BM",
    code: "+1441",
    flagEmoji: "🇧🇲",
  },
  {
    country: "Bhutan",
    shortForm: "BT",
    code: "+975",
    flagEmoji: "🇧🇹",
  },
  {
    country: "Bolivia, Plurinational State of",
    shortForm: "BO",
    code: "+591",
    flagEmoji: "🇧🇴",
  },
  {
    country: "Bosnia and Herzegovina",
    shortForm: "BA",
    code: "+387",
    flagEmoji: "🇧🇦",
  },
  {
    country: "Botswana",
    shortForm: "BW",
    code: "+267",
    flagEmoji: "🇧🇼",
  },
  {
    country: "Brazil",
    shortForm: "BR",
    code: "+55",
    flagEmoji: "🇧🇷",
  },
  {
    country: "British Indian Ocean Territory",
    shortForm: "IO",
    code: "+246",
    flagEmoji: "🇮🇴",
  },
  {
    country: "Brunei Darussalam",
    shortForm: "BN",
    code: "+673",
    flagEmoji: "🇧🇳",
  },
  {
    country: "Bulgaria",
    shortForm: "BG",
    code: "+359",
    flagEmoji: "🇧🇬",
  },
  {
    country: "Burkina Faso",
    shortForm: "BF",
    code: "+226",
    flagEmoji: "🇧🇫",
  },
  {
    country: "Burundi",
    shortForm: "BI",
    code: "+257",
    flagEmoji: "🇧🇮",
  },
  {
    country: "Cambodia",
    shortForm: "KH",
    code: "+855",
    flagEmoji: "🇰🇭",
  },
  {
    country: "Cameroon",
    shortForm: "CM",
    code: "+237",
    flagEmoji: "🇨🇲",
  },
  {
    country: "Canada",
    shortForm: "CA",
    code: "+1",
    flagEmoji: "🇨🇦",
  },
  {
    country: "Cape Verde",
    shortForm: "CV",
    code: "+238",
    flagEmoji: "🇨🇻",
  },
  {
    country: "Cayman Islands",
    shortForm: "KY",
    code: "+345",
    flagEmoji: "🇰🇾",
  },
  {
    country: "Central African Republic",
    shortForm: "CF",
    code: "+236",
    flagEmoji: "🇨🇫",
  },
  {
    country: "Chad",
    shortForm: "TD",
    code: "+235",
    flagEmoji: "🇹🇩",
  },
  {
    country: "Chile",
    shortForm: "CL",
    code: "+56",
    flagEmoji: "🇨🇱",
  },
  {
    country: "China",
    shortForm: "CN",
    code: "+86",
    flagEmoji: "🇨🇳",
  },
  {
    country: "Christmas Island",
    shortForm: "CX",
    code: "+61",
    flagEmoji: "🇨🇽",
  },
  {
    country: "Cocos (Keeling) Islands",
    shortForm: "CC",
    code: "+61",
    flagEmoji: "🇨🇨",
  },
  {
    country: "Colombia",
    shortForm: "CO",
    code: "+57",
    flagEmoji: "🇨🇴",
  },
  {
    country: "Comoros",
    shortForm: "KM",
    code: "+269",
    flagEmoji: "🇰🇲",
  },
  {
    country: "Congo",
    shortForm: "CG",
    code: "+242",
    flagEmoji: "🇨🇬",
  },
  {
    country: "Congo, The Democratic Republic of the Congo",
    shortForm: "CD",
    code: "+243",
    flagEmoji: "🇨🇩",
  },
  {
    country: "Cook Islands",
    shortForm: "CK",
    code: "+682",
    flagEmoji: "🇨🇰",
  },
  {
    country: "Costa Rica",
    shortForm: "CR",
    code: "+506",
    flagEmoji: "🇨🇷",
  },
  {
    country: "Cote d'Ivoire",
    shortForm: "CI",
    code: "+225",
    flagEmoji: "🇨🇮",
  },
  {
    country: "Croatia",
    shortForm: "HR",
    code: "+385",
    flagEmoji: "🇭🇷",
  },
  {
    country: "Cuba",
    shortForm: "CU",
    code: "+53",
    flagEmoji: "🇨🇺",
  },
  {
    country: "Cyprus",
    shortForm: "CY",
    code: "+357",
    flagEmoji: "🇨🇾",
  },
  {
    country: "Czech Republic",
    shortForm: "CZ",
    code: "+420",
    flagEmoji: "🇨🇿",
  },
  {
    country: "Denmark",
    shortForm: "DK",
    code: "+45",
    flagEmoji: "🇩🇰",
  },
  {
    country: "Djibouti",
    shortForm: "DJ",
    code: "+253",
    flagEmoji: "🇩🇯",
  },
  {
    country: "Dominica",
    shortForm: "DM",
    code: "+1767",
    flagEmoji: "🇩🇲",
  },
  {
    country: "Dominican Republic",
    shortForm: "DO",
    code: "+1849",
    flagEmoji: "🇩🇴",
  },
  {
    country: "Ecuador",
    shortForm: "EC",
    code: "+593",
    flagEmoji: "🇪🇨",
  },
  {
    country: "Egypt",
    shortForm: "EG",
    code: "+20",
    flagEmoji: "🇪🇬",
  },
  {
    country: "El Salvador",
    shortForm: "SV",
    code: "+503",
    flagEmoji: "🇸🇻",
  },
  {
    country: "Equatorial Guinea",
    shortForm: "GQ",
    code: "+240",
    flagEmoji: "🇬🇶",
  },
  {
    country: "Eritrea",
    shortForm: "ER",
    code: "+291",
    flagEmoji: "🇪🇷",
  },
  {
    country: "Estonia",
    shortForm: "EE",
    code: "+372",
    flagEmoji: "🇪🇪",
  },
  {
    country: "Ethiopia",
    shortForm: "ET",
    code: "+251",
    flagEmoji: "🇪🇹",
  },
  {
    country: "Falkland Islands (Malvinas)",
    shortForm: "FK",
    code: "+500",
    flagEmoji: "🇫🇰",
  },
  {
    country: "Faroe Islands",
    shortForm: "FO",
    code: "+298",
    flagEmoji: "🇫🇴",
  },
  {
    country: "Fiji",
    shortForm: "FJ",
    code: "+679",
    flagEmoji: "🇫🇯",
  },
  {
    country: "Finland",
    shortForm: "FI",
    code: "+358",
    flagEmoji: "🇫🇮",
  },
  {
    country: "France",
    shortForm: "FR",
    code: "+33",
    flagEmoji: "🇫🇷",
  },
  {
    country: "French Guiana",
    shortForm: "GF",
    code: "+594",
    flagEmoji: "🇬🇫",
  },
  {
    country: "French Polynesia",
    shortForm: "PF",
    code: "+689",
    flagEmoji: "🇵🇫",
  },
  {
    country: "Gabon",
    shortForm: "GA",
    code: "+241",
    flagEmoji: "🇬🇦",
  },
  {
    country: "Gambia",
    shortForm: "GM",
    code: "+220",
    flagEmoji: "🇬🇲",
  },
  {
    country: "Georgia",
    shortForm: "GE",
    code: "+995",
    flagEmoji: "🇬🇪",
  },
  {
    country: "Germany",
    shortForm: "DE",
    code: "+49",
    flagEmoji: "🇩🇪",
  },
  {
    country: "Ghana",
    shortForm: "GH",
    code: "+233",
    flagEmoji: "🇬🇭",
  },
  {
    country: "Gibraltar",
    shortForm: "GI",
    code: "+350",
    flagEmoji: "🇬🇮",
  },
  {
    country: "Greece",
    shortForm: "GR",
    code: "+30",
    flagEmoji: "🇬🇷",
  },
  {
    country: "Greenland",
    shortForm: "GL",
    code: "+299",
    flagEmoji: "🇬🇱",
  },
  {
    country: "Grenada",
    shortForm: "GD",
    code: "+1473",
    flagEmoji: "🇬🇩",
  },
  {
    country: "Guadeloupe",
    shortForm: "GP",
    code: "+590",
    flagEmoji: "🇬🇵",
  },
  {
    country: "Guam",
    shortForm: "GU",
    code: "+1671",
    flagEmoji: "🇬🇺",
  },
  {
    country: "Guatemala",
    shortForm: "GT",
    code: "+502",
    flagEmoji: "🇬🇹",
  },
  {
    country: "Guernsey",
    shortForm: "GG",
    code: "+44",
    flagEmoji: "🇬🇬",
  },
  {
    country: "Guinea",
    shortForm: "GN",
    code: "+224",
    flagEmoji: "🇬🇳",
  },
  {
    country: "Guinea-Bissau",
    shortForm: "GW",
    code: "+245",
    flagEmoji: "🇬🇼",
  },
  {
    country: "Guyana",
    shortForm: "GY",
    code: "+595",
    flagEmoji: "🇬🇾",
  },
  {
    country: "Haiti",
    shortForm: "HT",
    code: "+509",
    flagEmoji: "🇭🇹",
  },
  {
    country: "Holy See (Vatican City State)",
    shortForm: "VA",
    code: "+379",
    flagEmoji: "🇻🇦",
  },
  {
    country: "Honduras",
    shortForm: "HN",
    code: "+504",
    flagEmoji: "🇭🇳",
  },
  {
    country: "Hong Kong",
    shortForm: "HK",
    code: "+852",
    flagEmoji: "🇭🇰",
  },
  {
    country: "Hungary",
    shortForm: "HU",
    code: "+36",
    flagEmoji: "🇭🇺",
  },
  {
    country: "Iceland",
    shortForm: "IS",
    code: "+354",
    flagEmoji: "🇮🇸",
  },
  {
    country: "India",
    shortForm: "IN",
    code: "+91",
    flagEmoji: "🇮🇳",
  },
  {
    country: "Indonesia",
    shortForm: "ID",
    code: "+62",
    flagEmoji: "🇮🇩",
  },
  {
    country: "Iran, Islamic Republic of Persian Gulf",
    shortForm: "IR",
    code: "+98",
    flagEmoji: "🇮🇷",
  },
  {
    country: "Iraq",
    shortForm: "IQ",
    code: "+964",
    flagEmoji: "🇮🇷",
  },
  {
    country: "Ireland",
    shortForm: "IE",
    code: "+353",
    flagEmoji: "🇮🇪",
  },
  {
    country: "Isle of Man",
    shortForm: "IM",
    code: "+44",
    flagEmoji: "🇮🇲",
  },
  {
    country: "Israel",
    shortForm: "IL",
    code: "+972",
    flagEmoji: "🇮🇱",
  },
  {
    country: "Italy",
    shortForm: "IT",
    code: "+39",
    flagEmoji: "🇮🇹",
  },
  {
    country: "Jamaica",
    shortForm: "JM",
    code: "+1876",
    flagEmoji: "🇯🇲",
  },
  {
    country: "Japan",
    shortForm: "JP",
    code: "+81",
    flagEmoji: "🇯🇵",
  },
  {
    country: "Jersey",
    shortForm: "JE",
    code: "+44",
    flagEmoji: "🇯🇪",
  },
  {
    country: "Jordan",
    shortForm: "JO",
    code: "+962",
    flagEmoji: "🇯🇴",
  },
  {
    country: "Kazakhstan",
    shortForm: "KZ",
    code: "+77",
    flagEmoji: "🇰🇿",
  },
  {
    country: "Kenya",
    shortForm: "KE",
    code: "+254",
    flagEmoji: "🇰🇪",
  },
  {
    country: "Kiribati",
    shortForm: "KI",
    code: "+686",
    flagEmoji: "🇰🇮",
  },
  {
    country: "Korea, Democratic People's Republic of Korea",
    shortForm: "KP",
    code: "+850",
    flagEmoji: "🇰🇵",
  },
  {
    country: "Korea, Republic of South Korea",
    shortForm: "KR",
    code: "+82",
    flagEmoji: "🇰🇷",
  },
  {
    country: "Kuwait",
    shortForm: "KW",
    code: "+965",
    flagEmoji: "🇰🇼",
  },
  {
    country: "Kyrgyzstan",
    shortForm: "KG",
    code: "+996",
    flagEmoji: "🇰🇬",
  },
  {
    country: "Laos",
    shortForm: "LA",
    code: "+856",
    flagEmoji: "🇱🇦",
  },
  {
    country: "Latvia",
    shortForm: "LV",
    code: "+371",
    flagEmoji: "🇱🇻",
  },
  {
    country: "Lebanon",
    shortForm: "LB",
    code: "+961",
    flagEmoji: "🇱🇧",
  },
  {
    country: "Lesotho",
    shortForm: "LS",
    code: "+266",
    flagEmoji: "🇱🇸",
  },
  {
    country: "Liberia",
    shortForm: "LR",
    code: "+231",
    flagEmoji: "🇱🇷",
  },
  {
    country: "Libyan Arab Jamahiriya",
    shortForm: "LY",
    code: "+218",
    flagEmoji: "🇱🇾",
  },
  {
    country: "Liechtenstein",
    shortForm: "LI",
    code: "+423",
    flagEmoji: "🇱🇮",
  },
  {
    country: "Lithuania",
    shortForm: "LT",
    code: "+370",
    flagEmoji: "🇱🇹",
  },
  {
    country: "Luxembourg",
    shortForm: "LU",
    code: "+352",
    flagEmoji: "🇱🇺",
  },
  {
    country: "Macao",
    shortForm: "MO",
    code: "+853",
    flagEmoji: "🇲🇴",
  },
  {
    country: "Macedonia",
    shortForm: "MK",
    code: "+389",
    flagEmoji: "🇲🇰",
  },
  {
    country: "Madagascar",
    shortForm: "MG",
    code: "+261",
    flagEmoji: "🇲🇬",
  },
  {
    country: "Malawi",
    shortForm: "MW",
    code: "+265",
    flagEmoji: "🇲🇼",
  },
  {
    country: "Malaysia",
    shortForm: "MY",
    code: "+60",
    flagEmoji: "🇲🇾",
  },
  {
    country: "Maldives",
    shortForm: "MV",
    code: "+960",
    flagEmoji: "🇲🇻",
  },
  {
    country: "Mali",
    shortForm: "ML",
    code: "+223",
    flagEmoji: "🇲🇱",
  },
  {
    country: "Malta",
    shortForm: "MT",
    code: "+356",
    flagEmoji: "🇲🇹",
  },
  {
    country: "Marshall Islands",
    shortForm: "MH",
    code: "+692",
    flagEmoji: "🇲🇭",
  },
  {
    country: "Martinique",
    shortForm: "MQ",
    code: "+596",
    flagEmoji: "🇲🇶",
  },
  {
    country: "Mauritania",
    shortForm: "MR",
    code: "+222",
    flagEmoji: "🇲🇷",
  },
  {
    country: "Mauritius",
    shortForm: "MU",
    code: "+230",
    flagEmoji: "🇲🇺",
  },
  {
    country: "Mayotte",
    shortForm: "YT",
    code: "+262",
    flagEmoji: "🇾🇹",
  },
  {
    country: "Mexico",
    shortForm: "MX",
    code: "+52",
    flagEmoji: "🇲🇽",
  },
  {
    country: "Micronesia, Federated States of Micronesia",
    shortForm: "FM",
    code: "+691",
    flagEmoji: "🇫🇲",
  },
  {
    country: "Moldova",
    shortForm: "MD",
    code: "+373",
    flagEmoji: "🇲🇩",
  },
  {
    country: "Monaco",
    shortForm: "MC",
    code: "+377",
    flagEmoji: "🇲🇨",
  },
  {
    country: "Mongolia",
    shortForm: "MN",
    code: "+976",
    flagEmoji: "🇲🇳",
  },
  {
    country: "Montenegro",
    shortForm: "ME",
    code: "+382",
    flagEmoji: "🇲🇪",
  },
  {
    country: "Montserrat",
    shortForm: "MS",
    code: "+1664",
    flagEmoji: "🇲🇸",
  },
  {
    country: "Morocco",
    shortForm: "MA",
    code: "+212",
    flagEmoji: "🇲🇦",
  },
  {
    country: "Mozambique",
    shortForm: "MZ",
    code: "+258",
    flagEmoji: "🇲🇿",
  },
  {
    country: "Myanmar",
    shortForm: "MM",
    code: "+95",
    flagEmoji: "🇲🇲",
  },
  {
    country: "Namibia",
    shortForm: "NA",
    code: "+264",
    flagEmoji: "🇳🇦",
  },
  {
    country: "Nauru",
    shortForm: "NR",
    code: "+674",
    flagEmoji: "🇳🇷",
  },
  {
    country: "Nepal",
    shortForm: "NP",
    code: "+977",
    flagEmoji: "🇳🇵",
  },
  {
    country: "Netherlands",
    shortForm: "NL",
    code: "+31",
    flagEmoji: "🇳🇱",
  },
  {
    country: "Netherlands Antilles",
    shortForm: "AN",
    code: "+599",
    flagEmoji: "🇧🇶",
  },
  {
    country: "New Caledonia",
    shortForm: "NC",
    code: "+687",
    flagEmoji: "🇳🇨",
  },
  {
    country: "New Zealand",
    shortForm: "NZ",
    code: "+64",
    flagEmoji: "🇳🇿",
  },
  {
    country: "Nicaragua",
    shortForm: "NI",
    code: "+505",
    flagEmoji: "🇳🇮",
  },
  {
    country: "Niger",
    shortForm: "NE",
    code: "+227",
    flagEmoji: "🇳🇪",
  },
  {
    country: "Nigeria",
    shortForm: "NG",
    code: "+234",
    flagEmoji: "🇳🇬",
  },
  {
    country: "Niue",
    shortForm: "NU",
    code: "+683",
    flagEmoji: "🇳🇺",
  },
  {
    country: "Norfolk Island",
    shortForm: "NF",
    code: "+672",
    flagEmoji: "🇳🇫",
  },
  {
    country: "Northern Mariana Islands",
    shortForm: "MP",
    code: "+1670",
    flagEmoji: "🇲🇵",
  },
  {
    country: "Norway",
    shortForm: "NO",
    code: "+47",
    flagEmoji: "🇳🇴",
  },
  {
    country: "Oman",
    shortForm: "OM",
    code: "+968",
    flagEmoji: "🇴🇲",
  },
  {
    country: "Pakistan",
    shortForm: "PK",
    code: "+92",
    flagEmoji: "🇵🇰",
  },
  {
    country: "Palau",
    shortForm: "PW",
    code: "+680",
    flagEmoji: "🇵🇼",
  },
  {
    country: "Palestinian Territory, Occupied",
    shortForm: "PS",
    code: "+970",
    flagEmoji: "🇵🇸",
  },
  {
    country: "Panama",
    shortForm: "PA",
    code: "+507",
    flagEmoji: "🇵🇦",
  },
  {
    country: "Papua New Guinea",
    shortForm: "PG",
    code: "+675",
    flagEmoji: "🇵🇬",
  },
  {
    country: "Paraguay",
    shortForm: "PY",
    code: "+595",
    flagEmoji: "🇵🇾",
  },
  {
    country: "Peru",
    shortForm: "PE",
    code: "+51",
    flagEmoji: "🇵🇪",
  },
  {
    country: "Philippines",
    shortForm: "PH",
    code: "+63",
    flagEmoji: "🇵🇭",
  },
  {
    country: "Pitcairn",
    shortForm: "PN",
    code: "+872",
    flagEmoji: "🇵🇳",
  },
  {
    country: "Poland",
    shortForm: "PL",
    code: "+48",
    flagEmoji: "🇵🇱",
  },
  {
    country: "Portugal",
    shortForm: "PT",
    code: "+351",
    flagEmoji: "🇵🇹",
  },
  {
    country: "Puerto Rico",
    shortForm: "PR",
    code: "+1939",
    flagEmoji: "🇵🇷",
  },
  {
    country: "Qatar",
    shortForm: "QA",
    code: "+974",
    flagEmoji: "🇶🇦",
  },
  {
    country: "Reunion",
    shortForm: "RE",
    code: "+262",
    flagEmoji: "🇷🇪",
  },
  {
    country: "Romania",
    shortForm: "RO",
    code: "+40",
    flagEmoji: "🇷🇴",
  },
  {
    country: "Russia",
    shortForm: "RU",
    code: "+7",
    flagEmoji: "🇷🇺",
  },
  {
    country: "Rwanda",
    shortForm: "RW",
    code: "+250",
    flagEmoji: "🇷🇼",
  },
  {
    country: "Saint Barthelemy",
    shortForm: "BL",
    code: "+590",
    flagEmoji: "🇧🇱",
  },
  {
    country: "Saint Helena, Ascension and Tristan Da Cunha",
    shortForm: "SH",
    code: "+290",
    flagEmoji: "🇸🇭",
  },
  {
    country: "Saint Kitts and Nevis",
    shortForm: "KN",
    code: "+1869",
    flagEmoji: "🇰🇳",
  },
  {
    country: "Saint Lucia",
    shortForm: "LC",
    code: "+1758",
    flagEmoji: "🇱🇨",
  },
  {
    country: "Saint Martin",
    shortForm: "MF",
    code: "+590",
    flagEmoji: "🇲🇫",
  },
  {
    country: "Saint Pierre and Miquelon",
    shortForm: "PM",
    code: "+508",
    flagEmoji: "🇵🇲",
  },
  {
    country: "Saint Vincent and the Grenadines",
    shortForm: "VC",
    code: "+1784",
    flagEmoji: "🇻🇨",
  },
  {
    country: "Samoa",
    shortForm: "WS",
    code: "+685",
    flagEmoji: "🇼🇸",
  },
  {
    country: "San Marino",
    shortForm: "SM",
    code: "+378",
    flagEmoji: "🇸🇲",
  },
  {
    country: "Sao Tome and Principe",
    shortForm: "ST",
    code: "+239",
    flagEmoji: "🇸🇹",
  },
  {
    country: "Saudi Arabia",
    shortForm: "SA",
    code: "+966",
    flagEmoji: "🇸🇦",
  },
  {
    country: "Senegal",
    shortForm: "SN",
    code: "+221",
    flagEmoji: "🇸🇳",
  },
  {
    country: "Serbia",
    shortForm: "RS",
    code: "+381",
    flagEmoji: "🇷🇸",
  },
  {
    country: "Seychelles",
    shortForm: "SC",
    code: "+248",
    flagEmoji: "🇸🇨",
  },
  {
    country: "Sierra Leone",
    shortForm: "SL",
    code: "+232",
    flagEmoji: "🇸🇱",
  },
  {
    country: "Singapore",
    shortForm: "SG",
    code: "+65",
    flagEmoji: "🇸🇬",
  },
  {
    country: "Slovakia",
    shortForm: "SK",
    code: "+421",
    flagEmoji: "🇸🇰",
  },
  {
    country: "Slovenia",
    shortForm: "SI",
    code: "+386",
    flagEmoji: "🇸🇮",
  },
  {
    country: "Solomon Islands",
    shortForm: "SB",
    code: "+677",
    flagEmoji: "🇸🇧",
  },
  {
    country: "Somalia",
    shortForm: "SO",
    code: "+252",
    flagEmoji: "🇸🇴",
  },
  {
    country: "South Africa",
    shortForm: "ZA",
    code: "+27",
    flagEmoji: "🇿🇦",
  },
  {
    country: "South Georgia and the South Sandwich Islands",
    shortForm: "GS",
    code: "+500",
    flagEmoji: "🇬🇸",
  },
  {
    country: "South Sudan",
    shortForm: "SS",
    code: "+211",
    flagEmoji: "🇸🇸",
  },
  {
    country: "Spain",
    shortForm: "ES",
    code: "+34",
    flagEmoji: "🇪🇸",
  },
  {
    country: "Sri Lanka",
    shortForm: "LK",
    code: "+94",
    flagEmoji: "🇱🇰",
  },
  {
    country: "Sudan",
    shortForm: "SD",
    code: "+249",
    flagEmoji: "🇸🇩",
  },
  {
    country: "Suriname",
    shortForm: "SR",
    code: "+597",
    flagEmoji: "🇸🇷",
  },
  {
    country: "Svalbard and Jan Mayen",
    shortForm: "SJ",
    code: "+47",
    flagEmoji: "🇸🇯",
  },
  {
    country: "Swaziland",
    shortForm: "SZ",
    code: "+268",
    flagEmoji: "🇸🇿",
  },
  {
    country: "Sweden",
    shortForm: "SE",
    code: "+46",
    flagEmoji: "🇸🇪",
  },
  {
    country: "Switzerland",
    shortForm: "CH",
    code: "+41",
    flagEmoji: "🇨🇭",
  },
  {
    country: "Syrian Arab Republic",
    shortForm: "SY",
    code: "+963",
    flagEmoji: "🇸🇾",
  },
  {
    country: "Taiwan",
    shortForm: "TW",
    code: "+886",
    flagEmoji: "🇹🇼",
  },
  {
    country: "Tajikistan",
    shortForm: "TJ",
    code: "+992",
    flagEmoji: "🇹🇯",
  },
  {
    country: "Tanzania, United Republic of Tanzania",
    shortForm: "TZ",
    code: "+255",
    flagEmoji: "🇹🇿",
  },
  {
    country: "Thailand",
    shortForm: "TH",
    code: "+66",
    flagEmoji: "🇹🇭",
  },
  {
    country: "Timor-Leste",
    shortForm: "TL",
    code: "+670",
    flagEmoji: "🇹🇱",
  },
  {
    country: "Togo",
    shortForm: "TG",
    code: "+228",
    flagEmoji: "🇹🇬",
  },
  {
    country: "Tokelau",
    shortForm: "TK",
    code: "+690",
    flagEmoji: "🇹🇰",
  },
  {
    country: "Tonga",
    shortForm: "TO",
    code: "+676",
    flagEmoji: "🇹🇴",
  },
  {
    country: "Trinidad and Tobago",
    shortForm: "TT",
    code: "+1868",
    flagEmoji: "🇹🇹",
  },
  {
    country: "Tunisia",
    shortForm: "TN",
    code: "+216",
    flagEmoji: "🇹🇳",
  },
  {
    country: "Turkey",
    shortForm: "TR",
    code: "+90",
    flagEmoji: "🇹🇷",
  },
  {
    country: "Turkmenistan",
    shortForm: "TM",
    code: "+993",
    flagEmoji: "🇹🇲",
  },
  {
    country: "Turks and Caicos Islands",
    shortForm: "TC",
    code: "+1649",
    flagEmoji: "🇹🇨",
  },
  {
    country: "Tuvalu",
    shortForm: "TV",
    code: "+688",
    flagEmoji: "🇹🇻",
  },
  {
    country: "Uganda",
    shortForm: "UG",
    code: "+256",
    flagEmoji: "🇺🇬",
  },
  {
    country: "Ukraine",
    shortForm: "UA",
    code: "+380",
    flagEmoji: "🇺🇦",
  },
  {
    country: "United Arab Emirates",
    shortForm: "AE",
    code: "+971",
    flagEmoji: "🇦🇪",
  },
  {
    country: "United Kingdom",
    shortForm: "GB",
    code: "+44",
    flagEmoji: "🇬🇧",
  },
  {
    country: "United States",
    shortForm: "US",
    code: "+1",
    flagEmoji: "🇺🇸",
  },
  {
    country: "Uruguay",
    shortForm: "UY",
    code: "+598",
    flagEmoji: "🇺🇾",
  },
  {
    country: "Uzbekistan",
    shortForm: "UZ",
    code: "+998",
    flagEmoji: "🇺🇿",
  },
  {
    country: "Vanuatu",
    shortForm: "VU",
    code: "+678",
    flagEmoji: "🇻🇺",
  },
  {
    country: "Venezuela, Bolivarian Republic of Venezuela",
    shortForm: "VE",
    code: "+58",
    flagEmoji: "🇻🇪",
  },
  {
    country: "Vietnam",
    shortForm: "VN",
    code: "+84",
    flagEmoji: "🇻🇳",
  },
  {
    country: "Virgin Islands, British",
    shortForm: "VG",
    code: "+1284",
    flagEmoji: "🇻🇬",
  },
  {
    country: "Virgin Islands, U.S.",
    shortForm: "VI",
    code: "+1340",
    flagEmoji: "🇻🇮",
  },
  {
    country: "Wallis and Futuna",
    shortForm: "WF",
    code: "+681",
    flagEmoji: "🇼🇫",
  },
  {
    country: "Yemen",
    shortForm: "YE",
    code: "+967",
    flagEmoji: "🇾🇪",
  },
  {
    country: "Zambia",
    shortForm: "ZM",
    code: "+260",
    flagEmoji: "🇿🇲",
  },
  {
    country: "Zimbabwe",
    shortForm: "ZW",
    code: "+263",
    flagEmoji: "🇿🇼",
  },
];
